module.exports = __webpack_public_path__ + "static/media/integral_card_3.5d2b3e55.png";